import React, {Component} from 'react';
import firebase from 'firebase';
import 'moment/locale/es';
import './estilo.css';
import Select from 'react-select';
import tax from '../../img/taxs.png'
import { getAuth } from '../config/Paths'
import Alert from 'react-s-alert';

class ReservaEmpre extends Component {
  constructor(props) {
    super(props);
    this.state = {
      empleadosV:[],
      reservas:[],
      empresa:[],
      empresaFill:'', 
      clientes:[], 
      Empresa:[],
      ordeGenera:0

    };
  }
  componentWillMount(){
    
  }

  getData = () =>{
    firebase.database().ref('Clientes').once('value').then(snapC =>{
      let clientes = [];
      snapC.forEach(element =>{
        let clientesd = element.val();
        clientesd.key = element.key;
        clientes.push(clientesd);
      })
      firebase.database().ref('Empresa').once('value').then(snapE =>{
          let empresas = [];
          snapE.forEach(element2 =>{
            let objeE = element2.val();
            objeE.key = element2.key;
            empresas.push(objeE);
          })
          this.setState({clientes, Empresa:empresas});
          this.obteReservasC();
        })
    })
  }

  componentDidMount(){
    this.getData();
    this.cargarEmpleados();
    this.cargarEmpresa();
  }
  
  getData = () =>{
    firebase.database().ref('Clientes').once('value').then(snapC =>{
      let clientes = [];
      snapC.forEach(element =>{
        let clientesd = element.val();
        clientesd.key = element.key;
        clientes.push(clientesd);
      })
      firebase.database().ref('Empresa').once('value').then(snapE =>{
          let empresas = [];
          snapE.forEach(element2 =>{
            let objeE = element2.val();
            objeE.key = element2.key;
            empresas.push(objeE);
          })
          this.setState({clientes, Empresa:empresas});
          this.obteReservasC();
        })
    })
  }

  cargarEmpleados = () => {
    firebase.database().ref('Empleados').on('value', snap => {
      let empleadosV = [];
      snap.forEach(element => {
        let objeto = element.val();
        objeto.key = element.key;
        let nombre = objeto.nombre;
        let obj = { label: nombre, value: element.key };
        empleadosV.push(obj);
      });
      this.setState({
        empleado:empleadosV
      })
    })
  }

  cargarEmpresa = () => {
    firebase.database().ref('Empresa').once('value').then(snap => {
      let empresaV = [];
      let ob = { label: 'Todos', value: 'Todos' };
      empresaV.push(ob);  
      snap.forEach(element => {
        let obje = element.val();
        let nombre = obje.codigo_empresa;
        let ob = { label: nombre, value: element.key };
        empresaV.push(ob);
      });
      this.setState({
        empresa:empresaV
      })
    })
  }

  obteReservasC =() =>{
    let {clientes} = this.state;
    firebase.database().ref('Reservas').on('value', snap =>{
      let reservas =[];
      let index = 0;
      snap.forEach(element => {
        let datos = element.val();
        datos.key = element.key;
       
        let da = datos.fechaInicial;
        let fecha = da.split('-')
        let fechaRes = new Date(fecha[2]+'-'+fecha[1]+'-'+fecha[0] +' '+datos.horaInicial)
        let fechaAct = new Date();
        if(datos.estado !== 'programada' && datos.estado !== 'tomada' && fechaRes.getTime()>fechaAct.getTime()){
          let encontrardoConduct = clientes.find(emple => {
            return datos.cliente === emple.key;
          })
          datos.nombreE = encontrardoConduct.nombre +' ' + encontrardoConduct.apellido;
          datos.horaI = datos.horaInicial;
          datos.direccionO = datos.nombreInicio;
          if(datos.tipoV === 'dia'){
            datos.tipoViaje = 'Viaje por dia - Estandar';
          }
          if(datos.tipoV === 'multiple'){
            datos.tipoViaje = 'Multiples destinos - Estandar';
          }
          if(datos.tipoV === 'unico'){
            datos.tipoViaje = 'Unico destino - Estandar';
          }
          this.darValores(index);
          reservas.push(datos);
          index = index + 1;
        }
      })
      this.setState({reservas, ordeGenera:index});
      this.ObtenerReservas();
    })
  }

  asiganarViajesEmpresarial = (index,snap) =>{
    let id = 'emple'+index;
      if(this.state[id] !== ''){
        firebase.database().ref('Empleados/'+this.state[id]).once('value').then(snap3=>{
            let obje = snap3.val();

            firebase.database().ref('Vehiculos/'+obje.vehiculo).once('value').then(snap2 =>{
                let obje2 = snap2.val();
                let tipoV = '';
                if(obje.tipo_vehiculo === 'Unico destino - Empresarial'){
                  tipoV = 'comun';
                }
                if(obje.tipo_vehiculo === 'Multiples destinos - Empresarial'){
                  tipoV = 'Multiempresa';
                }
              var guardar = firebase.database().ref().child('AsignacionViajes').push({
                    emple:snap.emple,
                    empresa:snap.empresa,
                    fecha:snap.fechaRese,
                    horaF:snap.horaF,
                    horaFin:snap.horaFin,
                    horaI:snap.horaI,
                    horaIni:snap.horaIni,
                    inicio:snap.origen,
                    solicitante:snap.solicitante,
                    tipoVe:obje.tipo_vehiculo,
                    tipoViaje:tipoV,
                    viajeFinalizado:false,
                    viajeIniciado:false,
                    conduc:this.state[id],
                    estado:'Asignado',
                    movil:obje2.movil
                });
                firebase.database().ref().child('reserva/'+snap.key ).update({
                  asignada:true,
                })
                firebase.database().ref().child('Empleados/'+this.state[id] ).update({
                    ViajeActualE:guardar.key,
                    viajeEmpresa:'No disponible'
                })
            })
        })
      }
      else{
        Alert.warning('Favor seleccione un conductor para asignar la reserva', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
      }
  }

  ObtenerReservas(){
    let {empresaFill, Empresa, ordeGenera} = this.state;
    const monthNames = ["Ene", "Feb", "Mar", "Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
];
    firebase.database().ref('reserva').once('value', snap =>{
        let index = ordeGenera;
        let reservasd = [];
      snap.forEach(element => {
          let data = element.val();
          data.key = element.key;
          let encontrardoConduct = Empresa.find(emple => {
            return data.empresa === emple.key;
          })
          let fechaRes = new Date(data.fechaRese +' '+data.horaI);
          let fechaAct = new Date();
          if(data.asignada !== true && fechaRes.getTime() > fechaAct.getTime()){
            data.key = encontrardoConduct.key;
            data.nombreE = encontrardoConduct.codigo_empresa;
            let fechaRes = new Date(data.fechaRese)
            data.fechaInicial = fechaRes.getDate()+'-'+monthNames[fechaRes.getMonth()]+'-'+fechaRes.getFullYear();
            if(empresaFill === encontrardoConduct.key || empresaFill === '' || empresaFill === 'Todos'){
                this.darValores(index);
                reservasd.push(data);
                index = index + 1;
                this.setState({reservas:[...this.state.reservas,data]});
            }  
          }     
      });
    })
  }

  guardarConductor = (index,snap) =>{

      if(snap.tipoViaje === 'Unico destino - Empresarial' || snap.tipoViaje === 'Multiples destinos - Empresarial'){
        this.asiganarViajesEmpresarial(index,snap)
      }
      if(snap.tipoViaje === 'Unico destino - Estandar' || snap.tipoViaje ===  'Viaje por dia - Estandar'){
        this.saveUnico(index,snap);
      }
      if(snap.tipoViaje === 'Multiples destinos - Estandar'){
        this.saveMulti(index,snap);
      }
  }

  saveMulti = (index,snap)=>{ 
    let id = 'emple'+index;
    if(this.state[id] !== '')
    {
        let stopover = [snap.destinos].map(element => {
          let cantidadP = Object.keys(element).length;
          let stopove = '';
          for (let index = 0; index < cantidadP; index++) {
            let objeCli = element[Object.keys(element)[index]];//importante
            stopove = stopove +'|'+ objeCli.latitud +','+objeCli.longitud;
          } 
          return stopove;
        });
        let desde = snap.latitudInicial +','+snap.longitudInicial;
        let hacia = snap.latitudFinal +','+snap.longitudFinal;
        const proxyurl = "https://cors-anywhere.herokuapp.com/";
        fetch(proxyurl+`https://maps.googleapis.com/maps/api/directions/json?&mode=driving&language=es&origin=${desde}&destination=${hacia}&waypoints=optimize:true${stopover}&key=AIzaSyBWSezH7j1VKwfE36I0gsaaL8UwZh7cT0M`, getAuth())
        .then(response => response.json())
        .then(responseJSON => {
            let totalKil = 0;
            responseJSON.routes[0].legs.forEach(element => {
            totalKil = totalKil + element.distance.value
          });
          let kilometros = (totalKil/1000).toFixed(2);
          let total = 0;
            firebase.database().ref('Tarifas_Vehiculos/'+snap.TipoVehiculo).once('value').then(snapT =>{
              let datosT = snapT.val();
              if(kilometros <= 5) { total = datosT.d_5km  }
              if(kilometros > 5 && kilometros <= 10) { total = datosT.d_10km  }
              if(kilometros > 10 && kilometros <= 15) { total = datosT.d_15km }
              if(kilometros > 15 ) { total = datosT.mas_15km }
              firebase.database().ref().child('Reservas/'+snap.key).update({
                conductor:this.state[id],
                distancia: kilometros,
                total: total,
                estado:'programada',
                puntos:stopover,
                destinos:snap.destinos
              })
              this.setState({[id]:'', ordeGenera:0})
              Alert.success('Reserva asignada con exito', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
            })
        })
    }
    else{
      Alert.warning('Favor seleccione un conductor para asignar la reserva', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
    }
  }


  saveUnico = (index,snap) =>{
    let id = 'emple'+index;
    if(this.state[id] !== '')
    {
      let desde = snap.latitudInicial +','+snap.longitudInicial;
      let hacia = snap.latitudFinal +','+snap.longitudFinal;
      const proxyurl = "https://cors-anywhere.herokuapp.com/";
      fetch(proxyurl+'https://maps.googleapis.com/maps/api/directions/json?origin='+desde+'&destination='+hacia+'&key=AIzaSyBWSezH7j1VKwfE36I0gsaaL8UwZh7cT0M', getAuth() )
      .then(response => response.json())
      .then(responseJSON => {
        let tiem = (( responseJSON.routes[0].legs[0].distance.value)/1000).toFixed(2);
        let total = 0;
        firebase.database().ref('Tarifas_Vehiculos/'+snap.TipoVehiculo).once('value').then(snapT =>{
          let datosT = snapT.val();
          if(tiem <= 5) { total = datosT.d_5km  }
          if(tiem > 5 && tiem <= 10) { total = datosT.d_10km  }
          if(tiem > 10 && tiem <= 15) { total = datosT.d_15km }
          if(tiem > 15 ) { total = datosT.mas_15km }
          firebase.database().ref().child('Reservas/'+snap.key).update({
            conductor:this.state[id],
            distancia: tiem,
            total: total,
            estado:'programada'
          })
          this.setState({[id]:'', ordeGenera:0})
          Alert.success('Reserva asignada con exito', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
        })
      })
    }
    else{
      Alert.warning('Favor seleccione un conductor para asignar la reserva', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
    }
  }

  

  darValores = (index) =>{
    let id = 'emple'+index;
    this.setState({[id]:''})
    
  }

  addEmpreS = (event) =>{
    this.setState({empresaFill:event.value, reservas:[], ordeGenera:0});
    if(event.value === 'Todos'){
      this.obteReservasC();
    }else{
      this.ObtenerReservas();
    }
  }
  addCond = (event,index) =>{
    let id = 'emple'+index;
    this.setState({[id]:event.value});
  }

  render(){
    let { reservas, empleado, empresa } = this.state;
    return(
    <div>
      <div className="container">
        <div className="row header-margin-top">
          <div className="col-md-1">
            <img src={tax} alt="taxi" className="img-fluid m-top-img"/>
          </div>
          <div className="col-md-11">
            <h3 className="title-blue">Asignación de Reservas</h3>
            <span className="text-info">Visualización de conductores en reservas de viaje</span>
          </div>
        </div>
        <div className="row top-margin-filtros">
          <div className="col-12">
          <form>
                  <div className="form-row align-items-center">

                    <div className="col-sm-1 my-1">
                      <label className="text-gray">Empresa</label>
                    </div>
                    <div className="col-sm-2 my-1">
                      <Select onChange={this.addEmpreS} options={empresa} /> 
                    </div>
                  </div>
                </form>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
          <div className="table-responsive top-margin-table text-center">
            <table className="table">
              <tbody>
              <tr>
                <th>Solicitante</th>
                <th>Fecha de servicio</th>
                <th>Hora inicio</th>
                <th >Origen</th>
                <th>Tipo de viaje</th>
                <th colSpan="2">Asignar conductor</th>
              </tr>
                {
                  reservas.map((snap, index) =>{
                    if(snap.tipoViaje === 'comun') snap.tipoViaje ='Unico destino - Empresarial'; 
                    if(snap.tipoViaje === 'Multiempresa') snap.tipoViaje ='Multiples destinos - Empresarial'; 
                    if(snap.tipoViaje !== 'Multiempresa' && snap.tipoViaje !== 'comun') snap.tipoViaje = snap.tipoViaje;
                    return(
                      <tr key={index}>
                        <td>{snap.nombreE}</td>
                        <td>{snap.fechaInicial}</td>
                        <td>{snap.horaI}</td>
                        <td>{snap.direccionO}</td>
                        <td>{snap.tipoViaje}</td>
                        <td>
                        <div className="width-select-2">
                          <Select className="css-10nd86i-2" onChange={(event)=>this.addCond(event,index)} options={empleado} /> 
                        </div>
                        </td>
                        <td>
                          <button onClick={()=>this.guardarConductor(index,snap)} className="btn btn-small-green">+</button>
                        </td>
                      </tr>
                    )
                  })
                }
               
              </tbody>
            </table>
            </div>
          </div>
        </div>
    </div>
  </div>
    )
  }
}
export default ReservaEmpre;




// WEBPACK FOOTER //
// ./src/Components/Asignar/Asignar.jsx